import { useRef } from "react"
import { BsInfo } from "react-icons/bs"
import './components.css'

//
// @Nick
// This is not supposed to be any. help me. Im realy bad at typescripting
//
export function Tooltip({ slug, title, descriptionHTML }: any) {

    const tooltipRef = useRef<HTMLDivElement>(null)

    const handleMouseEnter = () => {
        if (tooltipRef.current) {
            tooltipRef.current.style.opacity = "1";
        }
    }

    const handleMouseLeave = () => {
        if (tooltipRef.current) {
            tooltipRef.current.style.opacity = "0";
        }
    }

    return (
        <div className="tooltip">
            <div className="tooltip__static">
                <BsInfo onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
                <p>{slug}</p>
            </div>

            <div ref={tooltipRef} className="tooltip__hoverable" style={{ opacity: 0, transition: "opacity 300ms" }}>
                <h2>{title}</h2>
                <p dangerouslySetInnerHTML={{ __html: descriptionHTML }}></p>
            </div>

        </div>
    )
}